import React from 'react';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Accordion from '@mui/material/Accordion';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';

export default function CustomAccordion({ accordionSummary, list }) {
    return (
      <Accordion disableGutters elevation={0}
      sx={{
        backgroundColor: '#500000',
        color: '#fff',
        "&.MuiAccordion-root:before": {
          display: 'none'
        }
      }}
    >
        <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }}/>}
            aria-controls="panel-content"
            id="panel-header"
        >
            {accordionSummary}
        </AccordionSummary>
        <AccordionDetails>
            <List>
                {list?.map((list) => (
                    <ListItem key={list.text} disablePadding sx={{ marginBottom: 0 }}>
                        <ListItemButton component={Link} to={list.path}>
                            <ListItemText primary={list.text} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </AccordionDetails>
    </Accordion>
    );
};